module.exports = __webpack_public_path__ + "static/Logo-a7bdf7ba816611c8fb7a818fecffb6c9.svg";